<template>
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
        <v-form ref="form" @submit.prevent="save">
            <v-row>
                <v-col class="px-4 mt-2" cols="12">
                    <div class="d-flex"
                        style="justify-content: space-between !important; align-items: center !important;">
                        <div>
                            <h2 class="main_title">
                               {{ viewType == 'add'?'Add': viewType == 'edit'?'Edit':"View" }} <span style=" color: rgb(8, 47, 177);">{{designation}}</span></h2>
                        </div>
                        <span @click="$emit('close')" class="mdi mdi-close"></span>
                    </div>
                </v-col>
            </v-row>

            <v-card-text>
                <v-row class="pa-0 mt-2">
                    <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
                        <v-radio-group
                        :showReadOnly="viewType == 'view'"
                        v-model="formData.status"
                        inline
                        >
                            <v-radio color="primary" label="Active" :value="'Active'"></v-radio>
                            <v-radio color="error" label="Inactive" :value="'Inactive'"></v-radio>
                        </v-radio-group>
                    </v-col>
    
                    <v-col cols='12' class="py-0 px-1">
                        <v-label>Contact Type<span style="color: red;">*</span></v-label>
                        <EnumAutoComplete class="dropdown" density="compact" v-model="formData.severity"
                    :selected="formData.key_type" :domain="'KEYTYPE'" placeholder="Contact Type" @changeEnumData="changeEnums($event)"
                    :rules="getRules('Contact Type')" :showReadOnly="isFormDisabled" />
                    </v-col>

                    <!-- <v-col cols='12' class="py-0 px-1">
                        <v-label>Code<span style="color: red;">*</span></v-label>
                        <AutoComplete 
                                placeholder="Code"
                                v-model="formData.code"
                                :rules="getRules('Code')"
                                item-value="warehouse_code"
                                item-title="warehouse_code"
                                multiple
                                :items="warehouse_name"
                            />
                    </v-col> -->

                    <v-col cols='12' v-if="formData.key_type == 'warehouse'" class="py-0 px-1">
                        <v-label>WareHouse<span style="color: red;">*</span></v-label>
                        <AutoComplete 
                            placeholder="Warehouse"
                            v-model="formData.wareHouse"
                            :rules="getRules('Warehouse')"
                            item-value="id"
                            item-title="warehouse_name"
                            multiple
                            return-object
                            :items="warehouse_name"
                        />
                    </v-col>

                     <v-col cols='12' v-if="formData.key_type == 'company'" class="py-0 px-1">
                        <v-label>Company<span style="color: red;">*</span></v-label>
                        <AutoComplete 
                            placeholder="Company"
                            v-model="formData.company"
                            :rules="getRules('Warehouse')"
                            item-value="id"
                            item-title="company_name"
                            multiple
                            return-object
                            :items="company_name"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-col cols="12" align="end">
                <v-btn @click="$emit('close')" class="cancel mr-3" color="gray">
                    Cancel
                </v-btn>
                <v-btn :showReadOnly="viewType == 'view'" type="submit" class="save" color="rgb(8, 47, 177)">Save</v-btn>
            </v-col>
        </v-form>
    </v-card>
</template>

<script>
import AutoComplete from "@/components/ui/AutoComplete.vue";
import clientDetailsService from "@/api/service/ClientDetails/ClientDetailsService";
// import TextFieldComponent from "@/components/TextFieldComponent.vue";
import EnumAutoComplete from "@/components/others/EnumAutoComplete.vue";

export default {
    components: {
        AutoComplete,
        // TextFieldComponent,
        EnumAutoComplete
    },
    props: {
        designation: String,
        editLocationData: Object,
        index: Number,
        viewType: String,
        users: Array,
        WHindex: Number,
        data: Object
        },
    data: () => ({
        formData: {
            // code: null,
            status:'Active',
            key_type:null,
            wareHouse:[],
        },
        chips: [],
        organisationData:[],
        warehouse_name: [],
        warehouse_code: [],
        localData:null,
    }),
    // props:['designation','editLocationData','index','viewType','users','WHindex','data'],
    created() {
        this.localData = this.data
        this.getWareHouseData()
        console.log(this.data,'data@@@')
    
        // this.formData = {
        //     id: this.editLocationData.id,
        //     first_name: this.editLocationData.first_name,
        //     last_name: this.editLocationData.last_name,
        //     email: this.editLocationData.email,
        //     status: this.editLocationData.status,
        //     mobile: this.editLocationData.mobile,
        //     created: this.editLocationData.created,
        //     created_by: this.editLocationData.created_by
        // }
    },
    
    methods: {
        changeEnums($event) {
            this.formData.key_type = $event
        },

        async getWareHouseData(){
            this.organisationData = await clientDetailsService.findOne({
              id: this.$route.query.id,
              collectionName: 'organisation'
            });
            this.warehouse_name = this.organisationData.wareHouse
            console.log(this.warehouse_name,"this.organisationData$$$$")
        },
        getRules(name) {
            if (name && name.toLowerCase() === "email") {
              return [
                (v) => !!v || "E-mail is required.",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
              ];
            }
            if (name && name.toLowerCase() === "warehouse") {
              return [
                (v) => {
                  if (this.users || this.viewType === 'edit') return true;
                  return !!v || "Warehouse is required.";
                },
                // (v) => {
                //   if (this.users || this.viewType === 'edit' || !v) return true;
                //   const warehouses = this.organisationData?.warehouse_details || [];
                //   const exists = warehouses.some(
                //     (org) =>
                //       org.warehouse_name &&
                //       org.warehouse_name.trim().toLowerCase() === v.trim().toLowerCase()
                //   );
                //   return exists ? "Warehouse already exists." : true;
                // },
              ];
            }
          return [(v) => !!v || `${name} is required.`];
        },
        async save() {
            this.localData.contactAccess = [ { ...this.formData } ];
            // this.data.wareHouseDetails = [...this.formData]
            console.log( this.localData,"this.formData*****")
          const result = await this.$refs.form.validate();
          if (result.valid) {
            if (this.viewType == "edit") {
              this.$emit("update-warehouse", this.formData, this.WHindex, this.index, this.viewType);
            } else if (this.viewType == "add") {
                alert('add')
              this.$emit("update-warehouse", this.formData, this.WHindex, this.viewType);
            } else {
              this.$emit("save", this.formData, this.designation);
            }
        
            this.formData = {};
            this.$emit("close");
          } else {
            console.log("Form not valid", result.errors);
          }
        },
    },

    // async mounted(){
    //     // if (!this.formData.status) {
    //     //     this.formData.status = "Active"
    //     // }
    //     // if(!this.users){
            
    //     // }
    // }
};
</script>
<style scoped>
.v-label {
    margin-bottom: 3px;
    font-size: 14px;
    opacity: 1;
    font-weight: 600;
}

.main_title {
    font-size: 16px;
    font-weight: 600;
}

.v-btn-toggle .v-btn {
    background-color: #E9DFFF;

}

.v-btn-toggle {
    height: 32px !important;
}
.ch {
    margin: auto;
    overflow-y: auto;
    min-height: 130px;
    max-height: 130px;
    overflow-x: hidden;
}
</style>
